import axios from "./axios";
const buildURL = url => {
  return `${axios.forceBIURL}/${url}`;
};
const handleErrors = reject => {
  return error => {
    if (error && error.message && error.message === 'cancel') return;
    if (error && error.response) {
      reject(error);
    } else if (error && error.request) {
      reject({
        code: 500,
        error: error.request
      });
    } else {
      console.error(error);
      reject({
        code: 500,
        error: 'unexpected-error'
      });
    }
  };
};
const get = url => {
  return new Promise((resolve, reject) => {
    return axios.get(buildURL(url)).then(response => resolve(response)).catch(handleErrors(reject));
  });
};
const post = (url, data) => {
  return new Promise((resolve, reject) => {
    return axios.post(buildURL(url), data).then(response => resolve(response)).catch(handleErrors(reject));
  });
};
const put = (url, data) => {
  return new Promise((resolve, reject) => {
    return axios.put(buildURL(url), data).then(response => resolve(response)).catch(handleErrors(reject));
  });
};
const del = url => {
  return new Promise((resolve, reject) => {
    return axios.delete(buildURL(url)).then(response => resolve(response)).catch(handleErrors(reject));
  });
};

// Get full dashboard information (dashboard data and widgets)
export const getDashboard = id => get(`Dashboards/v2/${id}`);

// Save Dashboard filters
export const saveDashboardFilters = (dashboardId, data) => put(`Dashboards/${dashboardId}/filters`, data);

// Get Charts and Tables via ID
export const getChartConfig = id => get(`DashboardItems/v2/${id}`);
export const getMapConfig = id => get(`DashboardItems/v2/${id}/map`);
export const getKpiConfig = id => get(`DashboardItems/v2/${id}/kpi`);
export const getTableConfig = id => get(`DashboardItems/v2/${id}/table`);

// Get Charts and Tables via widget data, filters and operators
export const getChartDynamicConfig = data => post(`DashboardItems/v2/configData`, data);
export const getMapDynamicConfig = data => post(`DashboardItems/v2/configData/map`, data);
export const getKpiDynamicConfig = data => post(`DashboardItems/v2/configData/kpi`, data);
export const getTableDynamicConfig = data => post(`DashboardItems/v2/configData/table`, data);

// CRUD fields queries to obtain valueLists
export const getEntities = () => {
  return new Promise((resolve, reject) => {
    get(`DashboardConfigs/v2/entities`).then(response => {
      resolve(response.data || []);
    }).catch(error => {
      reject(error);
    });
  });
};
export const getAxisData = (entity, axis) => {
  return new Promise((resolve, reject) => {
    get(`DashboardConfigs/v2/${entity}/${axis}`).then(response => {
      resolve(response.data || []);
    }).catch(error => {
      reject(error);
    });
  });
};
export const getAggregation = () => {
  return new Promise((resolve, reject) => {
    get(`DashboardConfigs/valueList/aggregation`).then(response => {
      resolve(response.data || []);
    }).catch(error => {
      reject(error);
    });
  });
};
export const getAggregationDate = () => {
  return new Promise((resolve, reject) => {
    get(`DashboardConfigs/valueList/aggregationDate`).then(response => {
      resolve(response.data || []);
    }).catch(error => {
      reject(error);
    });
  });
};
export const getXAxisBreakdown = entity => {
  return new Promise((resolve, reject) => {
    get(`DashboardConfigs/v2/${entity}/breakdown`).then(response => {
      resolve(response.data || []);
    }).catch(error => reject(error));
  });
};

//Expect full structure of widget with fields and filters object
export const createWidget = data => post(`DashboardItems/v2`, data);

//Expect full structure of widget with fields and filters object
export const updateWidget = (id, data) => put(`DashboardItems/v2/${id}`, data);
export const deleteWidget = id => del(`DashboardItems/${id}`);

//Expect array of ids
export const deleteMultipleWidgets = data => post(`DashboardItems/BulkDelete`, data);